import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as DollarIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowRightIcon } from "../../../Images/arrow-right-icon.svg";

export const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center  lg:flex-row flex-wrap  max-w-screen-lg mx-auto`}
`;
const Column = styled.div`
  ${tw`lg:w-1/4 max-w-xs `}
`;

const Card = styled.div`
  ${tw`flex flex-col items-center text-center h-full w-64  px-2 py-5`}
  .imageContainer {
    ${tw` items-start mt-3 rounded-full text-red-500  flex-shrink-0`}
    .image {
      ${tw`w-10 h-10 `}
    }
  }

  .textContainer {
    ${tw`mt-4 ml-2`}
  }

  .title {
    ${tw`mt-4  text-lg  h-5`}
  }

  .description {
    ${tw`mt-4 text-justify md:text-justify  sm:text-justify text-gray-600 leading-relaxed`}
    font-size: 16px;
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

const IconCard = ({ url, title, description, readmore, imageSrc }) => {
  const navigate = useNavigate();

  return (
    <Column>
      <Card onClick={() =>  readmore && navigate(`${url}`)} className= { readmore ? "group  group/item  hover:bg-red-100 cursor-pointer	" : "group  group/item  "} >
        <span className="imageContainer" >{imageSrc}</span>
        <span className="textContainer">
          <span  className="title">
            {title}
          </span>
          {/* <p className="description">
                  {description }
                </p> */}
        </span>
        {readmore &&  <span className="link   "><ArrowRightIcon className="icon rotate-45 group-hover:rotate-0" /></span>}
       
      </Card>
    </Column>
  );
};

export default IconCard;